import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';
import { useCallback, useMemo } from 'react';

export const DEFAULT_DATETIME_FORMAT = 'MM/dd h:mmaaa';
export const FILENAME_SAFE_DATETIME_FORMAT = 'MM-dd hh-mma';

export function useCurrentTime() {
  const timezone = useMemo(() => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch {
      return 'UTC'; // Fallback timezone
    }
  }, []);

  const getCurrentTime = useCallback(
    (dateTimeFormat: string = DEFAULT_DATETIME_FORMAT) => {
      try {
        const zonedDate = new TZDate(new Date(), timezone);
        return format(zonedDate, dateTimeFormat);
      } catch {
        return format(new Date(), dateTimeFormat); // Fallback formatting
      }
    },
    [timezone]
  );
  return { getCurrentTime };
}
